<script setup lang="ts">
import TrueFalseLabel from 'frontend/common/true-false-label.vue'
import { computed } from 'vue'

interface Props {
  yesCount?: number
  noCount?: number
  singleLabel: string
  multipleLabel: string
}

const props = withDefaults(defineProps<Props>(), {
  yesCount: 0,
  noCount: 0,
})

const totalCount = computed(() => props.yesCount + props.noCount)
const isUniform = computed(
  () => totalCount.value > 0 && (props.yesCount === 0 || props.noCount === 0),
)
const uniformValue = computed(() => props.yesCount > 0)
</script>

<template lang="pug">
span.text-black-15(v-if="!totalCount") empty
true-false-label(v-else-if="isUniform" :item="uniformValue")
div(v-else)
  .d-flex.align-items-center.gap-1(v-if="yesCount")
    span {{ yesCount }} {{ yesCount > 1 ? multipleLabel : singleLabel }}
    true-false-label(:item="true")
  .d-flex.align-items-center.gap-1.mt-1(v-if="noCount")
    span {{ noCount }} {{ noCount > 1 ? multipleLabel : singleLabel }}
    true-false-label(:item="false")
</template>
